export default "__VITE_ASSET__xThhwfSt__"